import { cn } from "@/lib/utils";
import React from "react";

export const EmptyState = ({
  title,
  description,
  actions,
  icon,
  className,
}: {
  title: string;
  icon?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode[] | React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn("flex w-full flex-col items-center gap-6 p-6", className)}
    >
      {icon ? (
        <div className="bg-muted flex size-16 items-center justify-center rounded-xl border p-4 shadow-xs [&_svg]:size-12">
          {icon}
        </div>
      ) : null}
      <div className="flex flex-col items-center gap-2 text-center">
        <h2 className="text-foreground text-lg font-semibold md:text-xl">
          {title}
        </h2>
        {description ? (
          <p className="text-muted-foreground text-sm leading-5 text-pretty max-w-md">
            {description}
          </p>
        ) : null}
      </div>
      <div className="flex w-full flex-col items-stretch justify-center gap-3 md:flex-row md:items-center">
        {actions}
      </div>
    </div>
  );
};
